var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer main-row"},[_c('div',{staticClass:"footer-body col col-xlg-12 col-lg-12 col-sm-12"},[_c('div',[_vm._v("中国科学院昆明植物研究所")]),_c('div',[_vm._v("备案序号： 【滇ICP备05000394号】")]),_c('div',[_vm._v("本数据库由云南省科技厅科技计划项目、中国科学院科学数据中心体系建设项目支持。")]),_c('div',[_vm._v("邮政编码：650201")]),_c('div',[_vm._v("联系地址：云南省昆明市盘龙区蓝黑路132号")])])])
}]

export { render, staticRenderFns }